var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7458 4.64505C19.68 4.43661 19.51 4.27838 19.2975 4.22665C19.0858 4.17493 18.8617 4.23749 18.7074 4.3916L16.8326 6.26587C16.3604 6.73795 15.6692 6.91679 15.0273 6.73309C14.4174 6.55855 13.9405 6.08177 13.766 5.47187C13.5823 4.82993 13.7612 4.13886 14.2333 3.66672L16.1084 1.79166C16.2633 1.63754 16.3251 1.41339 16.2733 1.2016C16.2216 0.989197 16.0634 0.819977 15.8549 0.753296C15.3217 0.585907 14.7542 0.5 14.1667 0.5C10.95 0.5 8.33328 3.11673 8.33328 6.33328C8.33328 7.01413 8.44757 7.67163 8.6734 8.29327L0.733337 16.2333C0.26001 16.7059 0 17.3333 0 18C0 18.6667 0.26001 19.2941 0.733337 19.7667C1.2059 20.24 1.83334 20.5 2.5 20.5C3.16666 20.5 3.7941 20.24 4.26666 19.7667L12.2067 11.8266C12.8284 12.0524 13.4859 12.1667 14.1667 12.1667C17.3833 12.1667 20 9.54999 20 6.33328C20 5.74582 19.9141 5.17834 19.7458 4.64505Z",
    fill: "#EAEEF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.5f64769ad205cee240c0668412737a88.svg";
export { ForwardRef as ReactComponent };